<template>
    <div class="modal-card card">
        <form @submit.prevent="onAddInitiatorField()">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">
                Add Initiator Field
            </h4>
            <!-- Close -->
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div class="card-body">
                <form-fields :fields="fields" v-model="initiatorField" />
        </div>
        <div class="card-footer">
            <div class="text-end">
                <submit-button :fields="fields" v-model="initiatorField" :loading="loading" />
            </div>
        </div>
        </form>
    </div>
</template>

<script>
import formFields from '../FormFields.vue';
import submitButton from '../SubmitButton.vue'
import {mapActions} from 'vuex'
import Fields from "../../utils/field-constants/initiatorFields";
export default {
    components: { formFields, submitButton },
    data(){
        return {
            initiatorField: {},
            //Note: deep copied so populating the initiator dropdown below does not
            //write the client's list onto the schema the global modal shares
            fields: JSON.parse(JSON.stringify(Fields)),
            loading:false
        }
    },
    name: "AddClientInitiatorField",
    beforeMount(){
        var self=this;
        //Note: a client field can point at a global initiator or one of the client's
        //own, so the dropdown is built from the merged list
        this.$store.dispatch("aut/fetchAllInitiators").then(()=>{
            this.fields.forEach((field)=>{
                if(field.name=="initiator"){
                    field.options=self.$store.getters["aut/initiatorOptions"].map((initiator)=>{
                        return {label: initiator.label, value: initiator.value }
                    })
                }
            })
        });
    },
    methods: {
        ...mapActions('aut', {
            createCidInitiatorField: 'createCidInitiatorField'
        }),
        async onAddInitiatorField() {
            this.loading = true;
            let toastOptions;
            try {
                await this.createCidInitiatorField(this.initiatorField)
                 toastOptions = {
                    message: "Successfully created new Initiator Field" + this.initiatorField.name + ".",
                    type: "success"
                }
            } catch (error) {
                this.loading = false;
                //Note: a duplicate name comes back as a 409 with an explanation the user
                //can act on, so surface it instead of the generic contact-support line.
                this.$store.dispatch("addToast", {
                    message: error.response && error.response.data && error.response.data.error
                        ? error.response.data.error
                        : "Failed to create initiator field " + this.initiatorField.name + ". Please contact support.",
                    type: "error"
                });
                return
            }
            this.$store.dispatch("addToast", toastOptions);
            this.loading = false;
            this.$store.dispatch('hideModal')
            this.$store.dispatch('aut/fetchCidInitiatorFields')
        }
    }
};
</script>

<style>
</style>
